import {
    CombosItemEvent,
    CombosItemEventDescription,
    CombosItemEventOdds,
} from './CombosItem/styled';
import Text from '../../ui/Text';
import React from 'react';
import { detectMobile } from '../../utils/UiHelper';
import { DotForTextAtBeginning, StyledPadding, ThreeDots } from '../../styled';

export const checkComboIsActive = (market, setMarkets) => {
    return setMarkets.includes(
        `REGULAR_BET_${market.market.marketId}_${
            market.outcome.betNr
        }_${market.market.marketName.replace(/\s/g, '')}`
    );
};

export const getComboItems = (markets, isModal = false, setMarkets = []) => {
    return markets.betItems.map((item, index) => {
        let eventName = item.market.eventName.split('-');
        return (
            <CombosItemEvent
                className={`${checkComboIsActive(item, setMarkets) &&
                    'active'}`}
                key={index}
            >
                <CombosItemEventDescription>
                    <Text
                        width={'100%'}
                        margin={'0'}
                        padding={'0'}
                        size={isModal || !detectMobile() ? '13' : '12'}
                        lh={isModal || !detectMobile() ? '20' : '20'}
                        flex={'0'}
                        bold
                        color={'#1e1e1e'}
                        alignItems={'center'}
                        justifyContent={'flex-start'}
                        display={'flex'}
                    >
                        <ThreeDots maxWidth={'100%'}>
                            {item.market.eventName}
                        </ThreeDots>
                    </Text>
                    <Text
                        width={'100%'}
                        margin={'0'}
                        padding={'0'}
                        size={'12'}
                        lh={'20'}
                        flex={'0'}
                        color={'#4F555E'}
                        alignItems={'center'}
                        justifyContent={'flex-start'}
                        display={'flex'}
                    >
                        <ThreeDots maxWidth={'calc(50% - 5px)'}>
                            {item.market.marketName}
                        </ThreeDots>
                        <DotForTextAtBeginning />
                        <ThreeDots maxWidth={'calc(50% - 5px)'}>
                            {item.outcome.competitor}
                        </ThreeDots>
                    </Text>
                </CombosItemEventDescription>
                <CombosItemEventOdds isModal>
                    {item.outcome.odds.toFixed(2)}
                </CombosItemEventOdds>
            </CombosItemEvent>
        );
    });
};

export const getVaixEventsIds = (
    events,
    isClick = false,
    clearEventId = false
) => {
    let ids = [];
    events.betItems.map((item) => {
        if (isClick) {
            ids.push({
                id: item.selectionId,
                event_id: item.selectionId.split('/')[1],
            });
        } else if (clearEventId) {
            ids.push(item.selectionId.split('/')[1]);
        } else {
            ids.push({
                id: item.selectionId.split('/')[1],
            });
        }
    });
    return ids;
};
